function u(s) {
  const t = [], o = [];
  let e = 0;
  for (const n of s)
    o.includes(n.name) ? (t[o.indexOf(n.name)].count += n.count, e += n.count) : (t.push(Object.assign({}, n)), o.push(n.name), e += n.count);
  for (const n of t)
    n.ratio = n.count / e;
  return t;
}
export {
  u as sumDistribution
};
//# sourceMappingURL=index10.js.map
